import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import DoneRoundedIcon from "@mui/icons-material/DoneRounded";
import { Box, IconButton, InputAdornment, Typography } from "@mui/material";
import { useCallback, useState } from "react";
import useColors from "../../../api/hooks/useColors";
import CustomToolTip from "../../../components/CustomTooltip";
import { StyledTextField } from "../../../components/forms/styles/formFieldStyles";

export default function DigestWithCopy({ digest }) {
  const colors = useColors();
  const [copied, setCopied] = useState(false);

  const handleCopy = useCallback(() => {
    navigator.clipboard.writeText(digest).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    });
  }, [digest]);

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 1,
        flex: 1,
        width: "400px",
      }}
    >
      <StyledTextField
        value={digest}
        overflow="hidden"
        textOverflow="ellipsis"
        display="flex"
        flexDirection="column"
        justifyContent="center"
        alignItems="flex-start"
        alignSelf="stretch"
        sx={{
          width: "100%",
          "& .MuiInputBase-input": {
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
          },
        }}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <CustomToolTip
                title={
                  copied ? (
                    <Box
                      sx={{ display: "flex", alignItems: "center", gap: 0.5 }}
                    >
                      <DoneRoundedIcon
                        sx={{ color: colors.success_main, width: "18px" }}
                      />
                      <Typography
                        variant="caption"
                        sx={{ color: colors.common_black }}
                      >
                        Copied to clipboard
                      </Typography>
                    </Box>
                  ) : (
                    <Typography
                      variant="caption"
                      sx={{ color: colors.common_black }}
                    >
                      Copy
                    </Typography>
                  )
                }
                placement="top"
              >
                <IconButton
                  onClick={handleCopy}
                  disableRipple
                  sx={{
                    padding: "6px",
                    borderRadius: "6px",
                    "&:hover": { backgroundColor: colors.grey_8percent },
                  }}
                >
                  <ContentCopyIcon sx={{ width: "18px", height: "18px" }} />
                </IconButton>
              </CustomToolTip>
            </InputAdornment>
          ),
        }}
      />
    </Box>
  );
}
